import SpecificMethodPage from "./SpecificMethodPage";
export default SpecificMethodPage;
